import React from 'react';
import { CTAButton } from './CTAButton';
import { CheckIcon } from 'lucide-react';
export function ProductStack() {
  return <section className="w-full py-20 px-4 border-t" style={{
    backgroundColor: '#f8fafc',
    borderColor: '#e2e8f0'
  }} data-id="element-313">
      <div className="max-w-3xl mx-auto" data-id="element-314">
        <h2 className="text-3xl md:text-4xl font-bold leading-tight mb-4 text-center" style={{
        color: '#0f172a'
      }} data-id="element-315">
          Lo Que Obtienes
        </h2>

        <p className="text-lg text-center mb-4" style={{
        color: '#64748b'
      }} data-id="element-316">
          📱{' '}
          <strong style={{
          color: '#0f172a'
        }} data-id="element-317">
            FORMATO:
          </strong>{' '}
          Guía Completa en PDF — descarga inmediata. Léela en tu celular,
          tablet, o computador.
        </p>
        <p className="text-lg font-bold text-center mb-12" style={{
        color: '#0f172a'
      }} data-id="element-318">
          Descarga. Lee. Ejecuta. Cobra.
        </p>

        <div className="space-y-6 mb-12" data-id="element-319">
          {/* Chapter 1 */}
          <div className="bg-white rounded-md p-6 border" style={{
          borderColor: '#e2e8f0'
        }} data-id="element-320">
            <div className="flex items-start gap-3 mb-3" data-id="element-321">
              <CheckIcon className="h-6 w-6 mt-0.5 flex-shrink-0" style={{
              color: '#f59e0b'
            }} aria-hidden="true" data-id="element-322" />
              <h3 className="text-lg font-bold" style={{
              color: '#0f172a'
            }} data-id="element-323">
                CAPÍTULO 1 — Cómo Funciona el Negocio Completo
              </h3>
            </div>
            <p className="text-base mb-4 ml-9" style={{
            color: '#64748b'
          }} data-id="element-324">
              Entiendes el modelo de negocio de principio a fin. Quién es tu
              cliente, qué necesita, cuánto paga y cómo encontrarlo.
            </p>
            <div className="overflow-x-auto ml-9 mb-3" data-id="element-325">
              <table className="w-full border-collapse rounded-md overflow-hidden text-sm" data-id="element-326">
                <tbody data-id="element-327">
                  <tr className="border-b" style={{
                  borderColor: '#e2e8f0'
                }} data-id="element-328">
                    <td className="p-3" style={{
                    color: '#64748b'
                  }} data-id="element-329">
                      Resultado
                    </td>
                    <td className="p-3 font-bold" style={{
                    color: '#0f172a'
                  }} data-id="element-330">
                      Claridad total del modelo
                    </td>
                  </tr>
                  <tr className="border-b" style={{
                  borderColor: '#e2e8f0'
                }} data-id="element-331">
                    <td className="p-3" style={{
                    color: '#64748b'
                  }} data-id="element-332">
                      Tiempo
                    </td>
                    <td className="p-3 font-bold" style={{
                    color: '#0f172a'
                  }} data-id="element-333">
                      30 min de lectura
                    </td>
                  </tr>
                  <tr data-id="element-334">
                    <td className="p-3" style={{
                    color: '#64748b'
                  }} data-id="element-335">
                      Nicho seleccionado
                    </td>
                    <td className="p-3 font-bold" style={{
                    color: '#0f172a'
                  }} data-id="element-336">
                      Día 1
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <p className="text-sm font-bold ml-9" style={{
            color: '#f59e0b'
          }} data-id="element-337">
              💰 Valor Real: $25.000 COP
            </p>
          </div>

          {/* Chapter 2 */}
          <div className="bg-white rounded-md p-6 border" style={{
          borderColor: '#e2e8f0'
        }} data-id="element-338">
            <div className="flex items-start gap-3 mb-3" data-id="element-339">
              <CheckIcon className="h-6 w-6 mt-0.5 flex-shrink-0" style={{
              color: '#f59e0b'
            }} aria-hidden="true" data-id="element-340" />
              <h3 className="text-lg font-bold" style={{
              color: '#0f172a'
            }} data-id="element-341">
                CAPÍTULO 2 — Configura tus Herramientas en 1 Hora
              </h3>
            </div>
            <p className="text-base mb-3 ml-9" style={{
            color: '#64748b'
          }} data-id="element-342">
              El paso a paso exacto para configurar ChatGPT y Magic Patterns.
              Con capturas de pantalla incluidas.
            </p>
            <p className="text-sm font-bold ml-9" style={{
            color: '#f59e0b'
          }} data-id="element-343">
              💰 Valor Real: $20.000 COP
            </p>
          </div>

          {/* Chapter 3 */}
          <div className="bg-white rounded-md p-6 border" style={{
          borderColor: '#e2e8f0'
        }} data-id="element-344">
            <div className="flex items-start gap-3 mb-3" data-id="element-345">
              <CheckIcon className="h-6 w-6 mt-0.5 flex-shrink-0" style={{
              color: '#f59e0b'
            }} aria-hidden="true" data-id="element-346" />
              <h3 className="text-lg font-bold" style={{
              color: '#0f172a'
            }} data-id="element-347">
                CAPÍTULO 3 — Los Prompts Exactos Para ChatGPT
              </h3>
            </div>
            <p className="text-base mb-4 ml-9" style={{
            color: '#64748b'
          }} data-id="element-348">
              La librería completa de instrucciones para generar textos
              profesionales en segundos. Incluye prompts para 8 nichos:
            </p>
            <div className="overflow-x-auto ml-9 mb-3" data-id="element-349">
              <table className="w-full border-collapse rounded-md overflow-hidden text-sm" data-id="element-350">
                <tbody data-id="element-351">
                  <tr className="border-b" style={{
                  borderColor: '#e2e8f0'
                }} data-id="element-352">
                    <td className="p-3" style={{
                    color: '#0f172a'
                  }} data-id="element-353">
                      🦷 Clínicas dentales
                    </td>
                    <td className="p-3 text-center" data-id="element-354">✅</td>
                  </tr>
                  <tr className="border-b" style={{
                  borderColor: '#e2e8f0',
                  backgroundColor: '#f8fafc'
                }} data-id="element-355">
                    <td className="p-3" style={{
                    color: '#0f172a'
                  }} data-id="element-356">
                      🏋️ Gimnasios y fitness
                    </td>
                    <td className="p-3 text-center" data-id="element-357">✅</td>
                  </tr>
                  <tr className="border-b" style={{
                  borderColor: '#e2e8f0'
                }} data-id="element-358">
                    <td className="p-3" style={{
                    color: '#0f172a'
                  }} data-id="element-359">
                      👔 Coaches y consultores
                    </td>
                    <td className="p-3 text-center" data-id="element-360">✅</td>
                  </tr>
                  <tr className="border-b" style={{
                  borderColor: '#e2e8f0',
                  backgroundColor: '#f8fafc'
                }} data-id="element-361">
                    <td className="p-3" style={{
                    color: '#0f172a'
                  }} data-id="element-362">
                      🏠 Agentes de bienes raíces
                    </td>
                    <td className="p-3 text-center" data-id="element-363">✅</td>
                  </tr>
                  <tr className="border-b" style={{
                  borderColor: '#e2e8f0'
                }} data-id="element-364">
                    <td className="p-3" style={{
                    color: '#0f172a'
                  }} data-id="element-365">
                      ⚖️ Firmas de abogados
                    </td>
                    <td className="p-3 text-center" data-id="element-366">✅</td>
                  </tr>
                  <tr className="border-b" style={{
                  borderColor: '#e2e8f0',
                  backgroundColor: '#f8fafc'
                }} data-id="element-367">
                    <td className="p-3" style={{
                    color: '#0f172a'
                  }} data-id="element-368">
                      💆 Spas y bienestar
                    </td>
                    <td className="p-3 text-center" data-id="element-369">✅</td>
                  </tr>
                  <tr className="border-b" style={{
                  borderColor: '#e2e8f0'
                }} data-id="element-370">
                    <td className="p-3" style={{
                    color: '#0f172a'
                  }} data-id="element-371">
                      🔨 Contratistas
                    </td>
                    <td className="p-3 text-center" data-id="element-372">✅</td>
                  </tr>
                  <tr data-id="element-373">
                    <td className="p-3" style={{
                    color: '#0f172a'
                  }} data-id="element-374">
                      🍕 Restaurantes
                    </td>
                    <td className="p-3 text-center" data-id="element-375">✅</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <p className="text-sm font-bold ml-9" style={{
            color: '#f59e0b'
          }} data-id="element-376">
              💰 Valor Real: $30.000 COP
            </p>
          </div>

          {/* Chapter 4 */}
          <div className="bg-white rounded-md p-6 border" style={{
          borderColor: '#e2e8f0'
        }} data-id="element-377">
            <div className="flex items-start gap-3 mb-3" data-id="element-378">
              <CheckIcon className="h-6 w-6 mt-0.5 flex-shrink-0" style={{
              color: '#f59e0b'
            }} aria-hidden="true" data-id="element-379" />
              <h3 className="text-lg font-bold" style={{
              color: '#0f172a'
            }} data-id="element-380">
                CAPÍTULO 4 — Construye tu Primera Página en Menos de 1 Hora
              </h3>
            </div>
            <p className="text-base mb-4 ml-9" style={{
            color: '#64748b'
          }} data-id="element-381">
              Guía visual paso a paso con capturas de pantalla para construir tu
              primera landing page en Magic Patterns. Sin código. Sin diseño.
              Sin experiencia.
            </p>
            <div className="overflow-x-auto ml-9 mb-3" data-id="element-382">
              <table className="w-full border-collapse rounded-md overflow-hidden text-sm" data-id="element-383">
                <tbody data-id="element-384">
                  <tr className="border-b" style={{
                  borderColor: '#e2e8f0'
                }} data-id="element-385">
                    <td className="p-3" style={{
                    color: '#64748b'
                  }} data-id="element-386">
                      Landing page profesional completa
                    </td>
                    <td className="p-3 font-bold" style={{
                    color: '#0f172a'
                  }} data-id="element-387">
                      Menos de 1 hora
                    </td>
                  </tr>
                  <tr className="border-b" style={{
                  borderColor: '#e2e8f0'
                }} data-id="element-388">
                    <td className="p-3" style={{
                    color: '#64748b'
                  }} data-id="element-389">
                      Funciona en celular y computador
                    </td>
                    <td className="p-3 font-bold" style={{
                    color: '#0f172a'
                  }} data-id="element-390">
                      Automático
                    </td>
                  </tr>
                  <tr data-id="element-391">
                    <td className="p-3" style={{
                    color: '#64748b'
                  }} data-id="element-392">
                      Primera pieza de portafolio
                    </td>
                    <td className="p-3 font-bold" style={{
                    color: '#0f172a'
                  }} data-id="element-393">
                      Día 1-2
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <p className="text-sm font-bold ml-9" style={{
            color: '#f59e0b'
          }} data-id="element-394">
              💰 Valor Real: $25.000 COP
            </p>
          </div>

          {/* Chapter 5 */}
          <div className="bg-white rounded-md p-6 border" style={{
          borderColor: '#e2e8f0'
        }} data-id="element-395">
            <div className="flex items-start gap-3 mb-3" data-id="element-396">
              <CheckIcon className="h-6 w-6 mt-0.5 flex-shrink-0" style={{
              color: '#f59e0b'
            }} aria-hidden="true" data-id="element-397" />
              <h3 className="text-lg font-bold" style={{
              color: '#0f172a'
            }} data-id="element-398">
                CAPÍTULO 5 — Cómo Encontrar a tus Primeros Clientes
              </h3>
            </div>
            <p className="text-base mb-4 ml-9" style={{
            color: '#64748b'
          }} data-id="element-399">
              Dónde encontrar negocios en Colombia que necesitan páginas web y
              los mensajes exactos que envías para conseguir tu primer cliente —
              sin ventas agresivas ni llamadas en frío.
            </p>
            <div className="overflow-x-auto ml-9 mb-3" data-id="element-400">
              <table className="w-full border-collapse rounded-md overflow-hidden text-sm" data-id="element-401">
                <tbody data-id="element-402">
                  <tr className="border-b" style={{
                  borderColor: '#e2e8f0'
                }} data-id="element-403">
                    <td className="p-3" style={{
                    color: '#64748b'
                  }} data-id="element-404">
                      50 negocios objetivo identificados
                    </td>
                    <td className="p-3 font-bold" style={{
                    color: '#0f172a'
                  }} data-id="element-405">
                      2 horas
                    </td>
                  </tr>
                  <tr className="border-b" style={{
                  borderColor: '#e2e8f0'
                }} data-id="element-406">
                    <td className="p-3" style={{
                    color: '#64748b'
                  }} data-id="element-407">
                      Primeros mensajes enviados
                    </td>
                    <td className="p-3 font-bold" style={{
                    color: '#0f172a'
                  }} data-id="element-408">
                      Día 3
                    </td>
                  </tr>
                  <tr data-id="element-409">
                    <td className="p-3" style={{
                    color: '#64748b'
                  }} data-id="element-410">
                      Primera respuesta de cliente
                    </td>
                    <td className="p-3 font-bold" style={{
                    color: '#0f172a'
                  }} data-id="element-411">
                      Días 3-5
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <p className="text-sm font-bold ml-9" style={{
            color: '#f59e0b'
          }} data-id="element-412">
              💰 Valor Real: $20.000 COP
            </p>
          </div>

          {/* Chapter 6 */}
          <div className="bg-white rounded-md p-6 border" style={{
          borderColor: '#e2e8f0'
        }} data-id="element-413">
            <div className="flex items-start gap-3 mb-3" data-id="element-414">
              <CheckIcon className="h-6 w-6 mt-0.5 flex-shrink-0" style={{
              color: '#f59e0b'
            }} aria-hidden="true" data-id="element-415" />
              <h3 className="text-lg font-bold" style={{
              color: '#0f172a'
            }} data-id="element-416">
                CAPÍTULO 6 — Cuánto Cobrar y Cómo Recibir Pagos
              </h3>
            </div>
            <p className="text-base mb-4 ml-9" style={{
            color: '#64748b'
          }} data-id="element-417">
              Exactamente cuánto cobrar por nicho y cómo recibir pagos de
              clientes en Colombia de forma segura desde cualquier lugar.
            </p>
            <div className="overflow-x-auto ml-9 mb-3" data-id="element-418">
              <table className="w-full border-collapse rounded-md overflow-hidden text-sm" data-id="element-419">
                <thead data-id="element-420">
                  <tr style={{
                  backgroundColor: '#0f172a'
                }} data-id="element-421">
                    <th className="text-left p-3 text-xs font-bold" style={{
                    color: '#f1f5f9'
                  }} data-id="element-422">
                      Nicho
                    </th>
                    <th className="text-left p-3 text-xs font-bold" style={{
                    color: '#f59e0b'
                  }} data-id="element-423">
                      Precio Recomendado
                    </th>
                  </tr>
                </thead>
                <tbody data-id="element-424">
                  <tr className="bg-white border-b" style={{
                  borderColor: '#e2e8f0'
                }} data-id="element-425">
                    <td className="p-3" style={{
                    color: '#0f172a'
                  }} data-id="element-426">
                      Clínica dental
                    </td>
                    <td className="p-3 font-bold" style={{
                    color: '#0f172a'
                  }} data-id="element-427">
                      $400.000 - $600.000
                    </td>
                  </tr>
                  <tr style={{
                  backgroundColor: '#f8fafc'
                }} className="border-b" data-id="element-428">
                    <td className="p-3" style={{
                    color: '#0f172a'
                  }} data-id="element-429">
                      Gimnasio
                    </td>
                    <td className="p-3 font-bold" style={{
                    color: '#0f172a'
                  }} data-id="element-430">
                      $350.000 - $500.000
                    </td>
                  </tr>
                  <tr className="bg-white border-b" style={{
                  borderColor: '#e2e8f0'
                }} data-id="element-431">
                    <td className="p-3" style={{
                    color: '#0f172a'
                  }} data-id="element-432">
                      Coach
                    </td>
                    <td className="p-3 font-bold" style={{
                    color: '#0f172a'
                  }} data-id="element-433">
                      $200.000 - $500.000
                    </td>
                  </tr>
                  <tr style={{
                  backgroundColor: '#f8fafc'
                }} className="border-b" data-id="element-434">
                    <td className="p-3" style={{
                    color: '#0f172a'
                  }} data-id="element-435">
                      Abogado
                    </td>
                    <td className="p-3 font-bold" style={{
                    color: '#0f172a'
                  }} data-id="element-436">
                      $500.000 - $800.000
                    </td>
                  </tr>
                  <tr className="bg-white border-b" style={{
                  borderColor: '#e2e8f0'
                }} data-id="element-437">
                    <td className="p-3" style={{
                    color: '#0f172a'
                  }} data-id="element-438">
                      Spa
                    </td>
                    <td className="p-3 font-bold" style={{
                    color: '#0f172a'
                  }} data-id="element-439">
                      $350.000 - $550.000
                    </td>
                  </tr>
                  <tr style={{
                  backgroundColor: '#f8fafc'
                }} className="border-b" data-id="element-440">
                    <td className="p-3" style={{
                    color: '#0f172a'
                  }} data-id="element-441">
                      Contratista
                    </td>
                    <td className="p-3 font-bold" style={{
                    color: '#0f172a'
                  }} data-id="element-442">
                      $200.000 - $450.000
                    </td>
                  </tr>
                  <tr className="bg-white" data-id="element-443">
                    <td className="p-3" style={{
                    color: '#0f172a'
                  }} data-id="element-444">
                      Restaurante
                    </td>
                    <td className="p-3 font-bold" style={{
                    color: '#0f172a'
                  }} data-id="element-445">
                      $200.000 - $400.000
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <p className="text-sm font-bold ml-9" style={{
            color: '#f59e0b'
          }} data-id="element-446">
              💰 Valor Real: $15.000 COP
            </p>
          </div>

          {/* Chapter 7 */}
          <div className="bg-white rounded-md p-6 border" style={{
          borderColor: '#e2e8f0'
        }} data-id="element-447">
            <div className="flex items-start gap-3 mb-3" data-id="element-448">
              <CheckIcon className="h-6 w-6 mt-0.5 flex-shrink-0" style={{
              color: '#f59e0b'
            }} aria-hidden="true" data-id="element-449" />
              <h3 className="text-lg font-bold" style={{
              color: '#0f172a'
            }} data-id="element-450">
                CAPÍTULO 7 — Entrega Profesional y Conseguir Referidos
              </h3>
            </div>
            <p className="text-base mb-3 ml-9" style={{
            color: '#64748b'
          }} data-id="element-451">
              La lista de verificación completa antes de entregar cada proyecto
              — y el mensaje exacto que envías después para conseguir referidos
              automáticos.
            </p>
            <p className="text-sm font-bold ml-9" style={{
            color: '#f59e0b'
          }} data-id="element-452">
              💰 Valor Real: $15.000 COP
            </p>
          </div>

          {/* Bonus 1 */}
          <div className="bg-white rounded-md p-6 border-2" style={{
          borderColor: '#f59e0b'
        }} data-id="element-453">
            <div className="flex items-start gap-3 mb-3" data-id="element-454">
              <CheckIcon className="h-6 w-6 mt-0.5 flex-shrink-0" style={{
              color: '#f59e0b'
            }} aria-hidden="true" data-id="element-455" />
              <h3 className="text-lg font-bold" style={{
              color: '#0f172a'
            }} data-id="element-456">
                BONO #1 — Plan Día a Día — 30 Días para tu Primer Cliente
              </h3>
            </div>
            <p className="text-base mb-4 ml-9" style={{
            color: '#64748b'
          }} data-id="element-457">
              Exactamente qué hacer cada uno de los primeros 30 días — desde
              descargar la guía hasta cobrar tu primer pago.
            </p>
            <div className="overflow-x-auto ml-9 mb-3" data-id="element-458">
              <table className="w-full border-collapse rounded-md overflow-hidden text-sm" data-id="element-459">
                <thead data-id="element-460">
                  <tr style={{
                  backgroundColor: '#0f172a'
                }} data-id="element-461">
                    <th className="text-left p-3 text-xs font-bold" style={{
                    color: '#f1f5f9'
                  }} data-id="element-462">
                      Semana
                    </th>
                    <th className="text-left p-3 text-xs font-bold" style={{
                    color: '#f1f5f9'
                  }} data-id="element-463">
                      Meta
                    </th>
                  </tr>
                </thead>
                <tbody data-id="element-464">
                  <tr className="bg-white border-b" style={{
                  borderColor: '#e2e8f0'
                }} data-id="element-465">
                    <td className="p-3 font-bold" style={{
                    color: '#0f172a'
                  }} data-id="element-466">
                      Semana 1
                    </td>
                    <td className="p-3" style={{
                    color: '#64748b'
                  }} data-id="element-467">
                      Herramientas listas + primera página demo
                    </td>
                  </tr>
                  <tr style={{
                  backgroundColor: '#f8fafc'
                }} className="border-b" data-id="element-468">
                    <td className="p-3 font-bold" style={{
                    color: '#0f172a'
                  }} data-id="element-469">
                      Semana 2
                    </td>
                    <td className="p-3" style={{
                    color: '#64748b'
                  }} data-id="element-470">
                      50 negocios contactados
                    </td>
                  </tr>
                  <tr className="bg-white border-b" style={{
                  borderColor: '#e2e8f0'
                }} data-id="element-471">
                    <td className="p-3 font-bold" style={{
                    color: '#0f172a'
                  }} data-id="element-472">
                      Semana 3
                    </td>
                    <td className="p-3" style={{
                    color: '#64748b'
                  }} data-id="element-473">
                      Primer cliente cerrado
                    </td>
                  </tr>
                  <tr style={{
                  backgroundColor: '#f8fafc'
                }} data-id="element-474">
                    <td className="p-3 font-bold" style={{
                    color: '#0f172a'
                  }} data-id="element-475">
                      Semana 4
                    </td>
                    <td className="p-3 font-bold" style={{
                    color: '#f59e0b'
                  }} data-id="element-476">
                      Primer pago recibido
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <p className="text-sm font-bold ml-9" style={{
            color: '#f59e0b'
          }} data-id="element-477">
              💰 Valor Real: $25.000 COP
            </p>
          </div>

          {/* Bonus 2 */}
          <div className="bg-white rounded-md p-6 border-2" style={{
          borderColor: '#f59e0b'
        }} data-id="element-478">
            <div className="flex items-start gap-3 mb-3" data-id="element-479">
              <CheckIcon className="h-6 w-6 mt-0.5 flex-shrink-0" style={{
              color: '#f59e0b'
            }} aria-hidden="true" data-id="element-480" />
              <h3 className="text-lg font-bold" style={{
              color: '#0f172a'
            }} data-id="element-481">
                BONO #2 — Plantilla de Propuesta Lista para Usar
              </h3>
            </div>
            <p className="text-base mb-3 ml-9" style={{
            color: '#64748b'
          }} data-id="element-482">
              El documento profesional que envías a un negocio cuando quieren
              contratarte. Ya escrito y listo. Solo cambias el nombre y el
              precio.
            </p>
            <p className="text-sm font-bold ml-9" style={{
            color: '#f59e0b'
          }} data-id="element-483">
              💰 Valor Real: $20.000 COP
            </p>
          </div>
        </div>

        {/* Summary Table */}
        <h3 className="text-2xl font-bold mb-6 text-center" style={{
        color: '#0f172a'
      }} data-id="element-484">
          RESUMEN COMPLETO
        </h3>

        <div className="overflow-x-auto mb-8" data-id="element-485">
          <table className="w-full border-collapse rounded-md overflow-hidden" data-id="element-486">
            <thead data-id="element-487">
              <tr style={{
              backgroundColor: '#0f172a'
            }} data-id="element-488">
                <th className="text-left p-4 text-sm font-bold" style={{
                color: '#f1f5f9'
              }} data-id="element-489">
                  #
                </th>
                <th className="text-left p-4 text-sm font-bold" style={{
                color: '#f1f5f9'
              }} data-id="element-490">
                  Lo Que Obtienes
                </th>
                <th className="text-right p-4 text-sm font-bold" style={{
                color: '#f59e0b'
              }} data-id="element-491">
                  Valor Real
                </th>
              </tr>
            </thead>
            <tbody data-id="element-492">
              <tr className="bg-white border-b" style={{
              borderColor: '#e2e8f0'
            }} data-id="element-493">
                <td className="p-4" data-id="element-494">✅</td>
                <td className="p-4" style={{
                color: '#0f172a'
              }} data-id="element-495">
                  Capítulo 1 — Cómo Funciona el Negocio
                </td>
                <td className="p-4 text-right font-bold" style={{
                color: '#0f172a'
              }} data-id="element-496">
                  $25.000
                </td>
              </tr>
              <tr style={{
              backgroundColor: '#f8fafc'
            }} className="border-b" data-id="element-497">
                <td className="p-4" data-id="element-498">✅</td>
                <td className="p-4" style={{
                color: '#0f172a'
              }} data-id="element-499">
                  Capítulo 2 — Configura tus Herramientas
                </td>
                <td className="p-4 text-right font-bold" style={{
                color: '#0f172a'
              }} data-id="element-500">
                  $20.000
                </td>
              </tr>
              <tr className="bg-white border-b" style={{
              borderColor: '#e2e8f0'
            }} data-id="element-501">
                <td className="p-4" data-id="element-502">✅</td>
                <td className="p-4" style={{
                color: '#0f172a'
              }} data-id="element-503">
                  Capítulo 3 — Librería de Prompts para ChatGPT
                </td>
                <td className="p-4 text-right font-bold" style={{
                color: '#0f172a'
              }} data-id="element-504">
                  $30.000
                </td>
              </tr>
              <tr style={{
              backgroundColor: '#f8fafc'
            }} className="border-b" data-id="element-505">
                <td className="p-4" data-id="element-506">✅</td>
                <td className="p-4" style={{
                color: '#0f172a'
              }} data-id="element-507">
                  Capítulo 4 — Construye tu Página en 1 Hora
                </td>
                <td className="p-4 text-right font-bold" style={{
                color: '#0f172a'
              }} data-id="element-508">
                  $25.000
                </td>
              </tr>
              <tr className="bg-white border-b" style={{
              borderColor: '#e2e8f0'
            }} data-id="element-509">
                <td className="p-4" data-id="element-510">✅</td>
                <td className="p-4" style={{
                color: '#0f172a'
              }} data-id="element-511">
                  Capítulo 5 — Encuentra tus Primeros Clientes
                </td>
                <td className="p-4 text-right font-bold" style={{
                color: '#0f172a'
              }} data-id="element-512">
                  $20.000
                </td>
              </tr>
              <tr style={{
              backgroundColor: '#f8fafc'
            }} className="border-b" data-id="element-513">
                <td className="p-4" data-id="element-514">✅</td>
                <td className="p-4" style={{
                color: '#0f172a'
              }} data-id="element-515">
                  Capítulo 6 — Precios y Pagos
                </td>
                <td className="p-4 text-right font-bold" style={{
                color: '#0f172a'
              }} data-id="element-516">
                  $15.000
                </td>
              </tr>
              <tr className="bg-white border-b" style={{
              borderColor: '#e2e8f0'
            }} data-id="element-517">
                <td className="p-4" data-id="element-518">✅</td>
                <td className="p-4" style={{
                color: '#0f172a'
              }} data-id="element-519">
                  Capítulo 7 — Entrega Profesional y Referidos
                </td>
                <td className="p-4 text-right font-bold" style={{
                color: '#0f172a'
              }} data-id="element-520">
                  $15.000
                </td>
              </tr>
              <tr style={{
              backgroundColor: '#f8fafc'
            }} className="border-b" data-id="element-521">
                <td className="p-4" data-id="element-522">✅</td>
                <td className="p-4" style={{
                color: '#0f172a'
              }} data-id="element-523">
                  Bono #1 — Plan de 30 Días
                </td>
                <td className="p-4 text-right font-bold" style={{
                color: '#0f172a'
              }} data-id="element-524">
                  $25.000
                </td>
              </tr>
              <tr className="bg-white border-b" style={{
              borderColor: '#e2e8f0'
            }} data-id="element-525">
                <td className="p-4" data-id="element-526">✅</td>
                <td className="p-4" style={{
                color: '#0f172a'
              }} data-id="element-527">
                  Bono #2 — Plantilla de Propuesta
                </td>
                <td className="p-4 text-right font-bold" style={{
                color: '#0f172a'
              }} data-id="element-528">
                  $20.000
                </td>
              </tr>
              <tr style={{
              backgroundColor: '#0f172a'
            }} data-id="element-529">
                <td className="p-4 font-bold" style={{
                color: '#f59e0b'
              }} data-id="element-530">
                  💰
                </td>
                <td className="p-4 font-bold" style={{
                color: '#f1f5f9'
              }} data-id="element-531">
                  Valor Real Total
                </td>
                <td className="p-4 text-right font-bold" style={{
                color: '#f59e0b'
              }} data-id="element-532">
                  $195.000
                </td>
              </tr>
              <tr style={{
              backgroundColor: '#f59e0b'
            }} data-id="element-533">
                <td className="p-4 font-bold" style={{
                color: '#0f172a'
              }} data-id="element-534">
                  🎯
                </td>
                <td className="p-4 font-bold text-xl" style={{
                color: '#0f172a'
              }} data-id="element-535">
                  Tu Inversión Hoy
                </td>
                <td className="p-4 text-right font-bold text-xl" style={{
                color: '#0f172a'
              }} data-id="element-536">
                  $49.999
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        {/* Costs Table */}
        <h3 className="text-xl font-bold mb-4" style={{
        color: '#0f172a'
      }} data-id="element-537">
          COSTOS REALES Y TRANSPARENTES
        </h3>

        <div className="overflow-x-auto mb-8" data-id="element-538">
          <table className="w-full border-collapse rounded-md overflow-hidden" data-id="element-539">
            <thead data-id="element-540">
              <tr style={{
              backgroundColor: '#0f172a'
            }} data-id="element-541">
                <th className="text-left p-4 text-sm font-bold" style={{
                color: '#f1f5f9'
              }} data-id="element-542">
                  Ítem
                </th>
                <th className="text-right p-4 text-sm font-bold" style={{
                color: '#f1f5f9'
              }} data-id="element-543">
                  Costo
                </th>
              </tr>
            </thead>
            <tbody data-id="element-544">
              <tr className="bg-white border-b" style={{
              borderColor: '#e2e8f0'
            }} data-id="element-545">
                <td className="p-4" style={{
                color: '#0f172a'
              }} data-id="element-546">
                  Guía PDF LPM™
                </td>
                <td className="p-4 text-right font-bold" style={{
                color: '#0f172a'
              }} data-id="element-547">
                  $49.999 (pago único)
                </td>
              </tr>
              <tr style={{
              backgroundColor: '#f8fafc'
            }} className="border-b" data-id="element-548">
                <td className="p-4" style={{
                color: '#0f172a'
              }} data-id="element-549">
                  ChatGPT
                </td>
                <td className="p-4 text-right font-bold" style={{
                color: '#16a34a'
              }} data-id="element-550">
                  $0 (gratis)
                </td>
              </tr>
              <tr style={{
              backgroundColor: '#f59e0b'
            }} data-id="element-551">
                <td className="p-4 font-bold" style={{
                color: '#0f172a'
              }} data-id="element-552">
                  Total primer mes
                </td>
                <td className="p-4 text-right font-bold" style={{
                color: '#0f172a'
              }} data-id="element-553">
                  $49.999
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <p className="text-lg font-bold text-center mb-12" style={{
        color: '#0f172a'
      }} data-id="element-554">
          Con tu primer proyecto de $200.000-$800.000 recuperas toda tu
          inversión el mismo mes.
        </p>

        <div className="text-center mb-2" data-id="element-555">
          <p className="text-sm" style={{
          color: '#dc2626'
        }} data-id="element-556">
            ⚠️ Precio de lanzamiento. Solo para las primeras 300 personas. Luego
            sube a $99.999.
          </p>
        </div>

        <CTAButton text="DESCARGAR LA GUÍA LPM™ COMPLETA POR SOLO $49.999" subtitle="✅ Valor total $195.000 COP · ✅ Descarga inmediata · ✅ Garantía de 30 días" scrollTo="ebook-main" data-id="element-557" />
      </div>
    </section>;
}